import { useState } from 'react'

// useLocalStorage soporta un namespace opcional para evitar colisiones en keys
export const useLocalStorage = (key, initialValue, namespace = '') => {
  const prefixedKey = namespace ? `${namespace}:${key}` : key
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === 'undefined') {
      return initialValue
    }
    try {
      const item = window.localStorage.getItem(prefixedKey)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      console.error(error)
      return initialValue
    }
  })

  const setValue = value => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(prefixedKey, JSON.stringify(valueToStore))
      }
    } catch (error) {
      console.error(error)
    }
  }

  return [storedValue, setValue]
}

// Borra todas las keys de localStorage que empiecen por `namespace:`
export const clearNamespace = namespace => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return
    if (!namespace) return
    const keysToRemove = []
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i)
      if (key && key.startsWith(`${namespace}:`)) keysToRemove.push(key)
    }
    keysToRemove.forEach(k => window.localStorage.removeItem(k))
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('clearNamespace failed:', e)
  }
}
